
import { AuditModel, PlanItemModel, PermissionTypeEnum, ProcessTypeEnum } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Ref, Watch } from 'vue-property-decorator';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import ShiftTypeSelect from '@/libs/common/components-smart/ShiftTypeSelect.vue';
import CustomerSelect from '@/libs/common/components-smart/CustomerSelect.vue';

@Component({
    components: { CustomerSelect, ShiftTypeSelect },
})
export default class WorkTaskEditDialog extends Page {
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    item: PlanItemModel | null = null;
    audit: AuditModel | null = null;
    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;

    @Ref() form!: any;

    @Watch('dialog')
    dialogChanged(v: boolean) {
        if (!v) this.close();
    }

    open(id: string) {
        this.item = null;
        this.audit = null;
        this.loading = true;
        this.dialog = true;
        planItemsStore.dispatch(CrudAction.Get, { id });
        this.subscribe(planItemsStore, CrudReponse.Get)
            .then((e: PlanItemModel) => {
                this.item = { ...e };
                this.audit = e.audit ?? null;
                if (!this.item.tenantUserId && e.tenantUser) {
                    this.item.tenantUserId = e.tenantUser.id;
                }
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
                this.dialog = false;
            });
    }

    close() {
        this.dialog = false;
        this.item = null;
        this.audit = null;
    }

    save() {
        if (this.form.validate()) {
            this.saving = true;
            const item = { ...this.item } as PlanItemModel;
            item.auditTenantUsers = [{ tenantUserId: item.tenantUserId! }];
            planItemsStore.dispatch(CrudAction.Update, { item });
            this.subscribe(planItemsStore, CrudReponse.Update)
                .then(() => {
                    this.saving = false;
                    this.close();
                    this.$emit('updated');
                })
                .catch(() => {
                    this.saving = false;
                });
        }
    }
}
